const MaintenancePage = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      textAlign: "center",
      padding: "1rem",
    }}
  >
    <div>
      <h1>We're Sorry</h1>
      <p>The website is currently under maintenance.</p>
      <p>Please check back later.</p>
    </div>
  </div>
);

export default MaintenancePage;
